export default __webpack_public_path__ + "static/media/trezi_logo-03.4d824fb2.png";